import router from "../router/index.js";
import axios from "axios";
export const errorModule = {
  state:()=> ({
    error: null, //Временно
  }),

  getters: {
    getError(state){
      return state.error
    }
  },

  mutations: {
    setError(state, error){
      state.error = error
    }
  },

  actions: {

  },

  namespaced: true
}
